import { render, staticRenderFns } from "./VerifyNotAuth.vue?vue&type=template&id=5b37d470&scoped=true"
import script from "./VerifyNotAuth.vue?vue&type=script&lang=js"
export * from "./VerifyNotAuth.vue?vue&type=script&lang=js"
import style0 from "./VerifyNotAuth.vue?vue&type=style&index=0&id=5b37d470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37d470",
  null
  
)

export default component.exports